<template>
	<div class="container print">
		<div class="row">
			<div class="col-12">
				<h1>{{this.$attrs.name}} History</h1>
			</div>
		</div>
		<p id="noHistory" v-if="!history.length">No history found</p>
		<table v-if="history.length" class="item-table history-table">
			<thead>
				<tr class="item-headers">
					<th>
						<div class="bar bg-blue">
							<h3>Date</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Name</h3>
						</div> 
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Lot</h3>
						</div> 
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Tasks</h3>
						</div> 
					</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="(history, index) in history" :key="index">
					<td>{{history.date.split('T')[0]}}</td>
					<td>{{history.name ? history.name : ''}}</td>
					<td>{{history.lot_num ? history.lot_num : ''}}</td>
					<td>{{history.tasks ? parseTasks(history.tasks) : '' }}</td>
				</tr>
			</tbody>
		</table>

	</div>
</template>

<script>
import { mapState } from 'vuex'
import history from '../../lib/history';

export default {
	data() {
		return {
			history: {}
		}
	},
	computed : {
		...mapState({
			tasks: state => state.tasks.list
		}),
		tasks() {
			return this.mapArrayById(this.$store.getters['tasks/list'], 'id')
		},
	},
	methods: {
		parseTasks(ids) {
			if(!ids ||  Object.keys(this.tasks).length === 0) {
				return ''
			}
			ids = ids.split(',')
			//Maps through ids matching them with the name and then filters out the non unique tasks
			return [...new Set(ids.map(id => this.tasks[id].name))].join(', ');
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)

		history[this.$attrs.type](this.$attrs.id)
		.then(res => {
			this.$store.commit('app/setLoading', false);
			this.history = res
			window.print();
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})

		this.$store.commit('app/setLoading', true)
		this.$store.dispatch('tasks/getList')
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">
@import '../../scss/variables.scss';
#noHistory {
	color: $error_color;
	font-weight: 600;
}
.history-table {
	tr {
		h3 {
			color: white !important;
			font-weight: bold !important;
			font-size: 18px !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Print.vue